import CircleIcon from 'components/CircleIcon';
import QuoteBookingComponentIcon from 'components/quoteBooking/QuoteBookingComponentIcon';
import SectionTitle from 'components/typography/SectionTitle';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { COMPONENT_CRUISE } from 'shared/constants/common';
import CruisesItem from './CruisesItem';

export default function Cruises({ cruisesList = [], isBooking = false }) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <QuoteBookingComponentIcon
            componentType={COMPONENT_CRUISE}
            fillColor={primaryColour}
          />
        </CircleIcon>
        <SectionTitle label="Cruises" className="ml-[10px] mt-1" />
      </div>
      {cruisesList.map((cruise, index) => (
        <div key={`${index + 1}`} className="mt-[40px]">
          <CruisesItem cruise={cruise} isBooking={isBooking} />
        </div>
      ))}
    </>
  );
}
